import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGifMakerConfig } from '@/data/landingConfig/landingGifMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GifMaker } from './schemaObject';

interface Props {}
const GifMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GifMaker} />
			<VideoLandingTemplate
				data={landingGifMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default GifMaker;
